import { ROUTE_BUSINESS_PROFILES } from '@@partner:config/routes'
import { useRedirectTo } from '@@partner:helpers/hooks/location'
import BusinessProfileForm from '@components/businessProfiles/BusinessProfileForm'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Panel } from 'rsuite'


export default function BusinessProfilePage () {
  const { profileId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_BUSINESS_PROFILES, {
    brandSlug
  })

  return (
    <div className="CustomerFormPage">
      <h1 className="u-heading">
        {profileId ? 'Редактирование' : 'Добавление'} компании
      </h1>
      <BusinessProfileForm profileId={profileId} onSaved={redirectToCatalog} />
    </div>
  )
}